import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DbSelectLookUpModel, MaterialAliasModel, MaterialTypeModel } from '../Modules/settings/models';
import { AvailableParents, ConnectorChild, PlantList } from '../Modules/idms/components/plant-manager/models/plant-manager.model';
import { InputGroup } from '../Modules/informate/models/calculationModels';
import { taggedItemTrail, taggedItems } from '../Modules/idms/components/project-manager/models/ProjectActivityPackDetails.model';
import { environment } from 'src/environments/environment';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { APIRes } from '../Modules/idms/models/commonAPI.model';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FlangeMaterialModel, GasketModel } from '../Modules/informate/models';
import { SaerchedTaggedItem, SearchedDocumnt, SearchedProject } from '../Modules/idms/components/idms/idms-site-search/models/siteSearchTaggedItemModel';
import { EnvironmentService } from './environment.service';

@Injectable({
    providedIn: 'root',
})
export class IdmApiService {
    headers: HttpHeaders;
    loggedInUserId: string;

    private idmApi = environment.idmApi;
    private subVal = '';

    constructor(
        private http: HttpClient,
        private msalService: MsalService,
        private ngxUiLoaderService: NgxUiLoaderService,
        private EnvironmentService: EnvironmentService,
        private appInsights: ApplicationInsights
    ) {
        this.subVal = this.EnvironmentService.getConfig().subValue;
    }

    // * api call to get the db selects by instanceId
    getDbSelectsByInstanceId(instanceId: string): Observable<APIRes<DbSelectLookUpModel[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });

        return this.http.get(`${this.idmApi}databaseselects/getdatabaseselects`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to save the db selects changes
    saveDbSelectsChanges(instanceId: string, dbSelectData: DbSelectLookUpModel[]): Observable<APIRes<any>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });
        return this.http
            .put(`${this.idmApi}databaseselects`, dbSelectData, {
                headers: this.headers,
            })
            .pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the material alias types
    getMaterialAliasTypes(instanceId: string): Observable<APIRes<MaterialTypeModel[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });
        return this.http.get(`${this.idmApi}materialalias/getmaterialtypes`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the material alias by instance id
    getMaterialAliasById(instanceId: string): Observable<APIRes<MaterialAliasModel[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });

        return this.http.get(`${this.idmApi}materialalias/getmaterialaliases`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to save material alias changes
    saveMaterialAliasChanges(instanceId: string, payload: MaterialAliasModel[]): Observable<APIRes<any>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });
        return this.http.put(`${this.idmApi}materialalias`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    private handleError(error: any) {
        this.loggedInUserId = this.msalService?.instance?.getActiveAccount()?.idTokenClaims?.oid;
        let currOrg = localStorage.getItem('selectedOrgId');
        let currInstance = localStorage.getItem('currentInstanceId');
        if (error instanceof ErrorEvent) {
            console.error('An error occurred:', error.message);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.loggedInUserId },
            });
            this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.loggedInUserId } });
        } else {
            console.error(`Backend returned code ${error.status}, ` + `body was: ${error.message}`);
            this.appInsights.trackException({
                exception: new Error(error.message),
                properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.loggedInUserId },
            });
            this.appInsights.trackPageView({ properties: { currOrg: currOrg, currentInstanceId: currInstance, oid: this.loggedInUserId } });
        }
        this.ngxUiLoaderService.stop();
        return throwError('Something bad happened; please try again later.');
    }

    // * api call to get the pipe Specification by instanceId
    getpipeSpecByInstanceId(instanceId): Observable<APIRes<any>> {
        // instanceId='378C8F02-2DA4-4BA9-8335-394CDA78E2CC'
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });
        return this.http.get(`${this.idmApi}pipespecs/getpipecodes`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the pipe Specification by instanceId
    PutpipeSpecByInstanceId(payload: any, instanceId: string): Observable<APIRes<any>> {
        // instanceId='378C8F02-2DA4-4BA9-8335-394CDA78E2CC'
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });
        return this.http.put(`${this.idmApi}pipespecs`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // * api call to get the db selects values  by instanceId
    getDbSelectsValuesByInstanceId(instanceId: string, dbSelectKey): Observable<APIRes<DbSelectLookUpModel[]>> {
        this.headers = new HttpHeaders({
            'Ocp-Apim-Subscription-Key': this.subVal,
            Authorization: `Bearer ${localStorage.getItem('msal.accessToken')}`,
            instanceId,
        });

        let queryParams;
        if (dbSelectKey) {
            queryParams = new HttpParams().set('databaseSelectName', dbSelectKey);
        }
        return this.http
            .get(`${this.idmApi}databaseselects/getdatabaseselectvalues`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //Find TaggedItems
    findtaggeditems(Criteria: string): Observable<{ success: boolean; isCustom?: boolean; message?: string; response?: any }> {
        const url = `${this.idmApi}taggeditems/findtaggeditems?Criteria=${Criteria}`; //`
        this.addPostAndPutHeaders();
        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    addPostAndPutHeaders() {
        this.headers = new HttpHeaders();
        this.headers = this.headers.append('Ocp-Apim-Subscription-Key', this.subVal);
        this.headers = this.headers.append('Accept', 'application/json;');
        this.headers = this.headers.append('Access-Control-Allow-Origin', '*/*');
        this.headers = this.headers.append('content-type', 'application/json');
        this.headers = this.headers.append('InstanceId', `${localStorage.getItem('currentInstanceId')}`);
        this.headers = this.headers.append('Authorization', `Bearer ${localStorage.getItem('msal.accessToken')}`);
    }

    private createHttpParams(params: {}): HttpParams {
        let httpParams: HttpParams = new HttpParams();
        Object.keys(params).forEach((param) => {
            if (params[param]) {
                httpParams = httpParams.set(param, params[param]);
            }
        });

        return httpParams;
    }
    //***************API Call to get Tagged item with instance, hierarchy and parent id************************** */
    gettaggeditemchildren(hierarchyId: string, ParentId?: string): Observable<APIRes<PlantList[]>> {
        this.addPostAndPutHeaders();
        let queryParams;

        if (ParentId) {
            queryParams = new HttpParams().set('HierarchyId', hierarchyId).set('ParentId', ParentId);
        } else {
            queryParams = new HttpParams().set('HierarchyId', hierarchyId);
        }
        return this.http
            .get(`${this.idmApi}connectors/gettaggeditemchildren`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get Tagged item connector type with instance, hierarchy and parent id************************** */
    gettaggeditemconnectors(hierarchyId: string, ParentId?: string): Observable<APIRes<ConnectorChild[]>> {
        this.addPostAndPutHeaders();
        let queryParams;

        if (ParentId) {
            queryParams = new HttpParams().set('HierarchyId', hierarchyId).set('ParentId', ParentId);
        } else {
            queryParams = new HttpParams().set('HierarchyId', hierarchyId);
        }
        return this.http
            .get(`${this.idmApi}connectors/gettaggeditemconnectors`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get Tagged item by type************************** */
    GetTaggedItemByTypes(Types: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http
            .post(`${this.idmApi}taggeditems/gettaggeditemsbytypes`, Types, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to post tagged items from existing data************************** */
    postConnectors(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.idmApi}connectors`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to post tagged items from existing data************************** */
    updateIsfavourite(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.idmApi}taggeditems/favourite`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to create new  tagged items ************************** */
    postTaggedItems(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.idmApi}taggeditems`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get Tagged Item Data By Tagged Item Id to edit************************** */
    GetTaggedItemDataById(taggedItemId: string): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.idmApi}taggedItems/` + taggedItemId, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to delete  tagged items ************************** */
    deleteTaggedItems(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.idmApi}taggeditems`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to delete  tagged items ************************** */
    removeTaggedItemChild(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.idmApi}connectors`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to create new  tagged items ************************** */
    updateTaggedItems(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.idmApi}taggeditems`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to move tagged items************************** */
    putConnectors(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.idmApi}connectors`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to get Tagged item avcailable parents, hierarchy and parent id************************** */
    GetTaggedItemAvailableParents(hierarchyId: string, taggedItemId: string): Observable<APIRes<AvailableParents[]>> {
        this.addPostAndPutHeaders();
        let queryParams;

        queryParams = new HttpParams().set('HierarchyId', hierarchyId).set('taggedItemId', taggedItemId);

        return this.http
            .get(`${this.idmApi}connectors/GetTaggedItemAvailableParents`, { headers: this.headers, params: queryParams })
            .pipe(catchError(this.handleError.bind(this)));
    }

    //Api call for finding pipeSpec
    findpipespecs(payload: any): Observable<APIRes<InputGroup[]>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.idmApi}pipespecs/findpipespecs`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //method for finding tagged items for allocating
    findtaggeditemdescendantsforallocation(taggedItemToallocate, taggedItemid: string): Observable<APIRes<taggedItems[]>> {
        const url = `${this.idmApi}/connectors/${taggedItemToallocate}/${taggedItemid}`; //`
        this.addPostAndPutHeaders();

        return this.http.get(url, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    // ***************API Call to get Tagged Item Itail by Tagged Item Id to edit************************** */
    GetTaggedItemTrailById(taggedItemId: string): Observable<APIRes<taggedItemTrail[]>> {
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.idmApi}taggeditems/gettaggeditemtrail/` + taggedItemId, { headers: this.headers })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getCalcBoltMaterials(standardId?: string, isCustom?: boolean) {
        const params: HttpParams = this.createHttpParams({ standardId: standardId, isCustom: isCustom });
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.idmApi}calculations/getboltmaterials`, { headers: this.headers, params: params })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getCalcFlangeMaterials(standardId?: string, isCustom?: boolean): Observable<APIRes<FlangeMaterialModel[]>> {
        const params: HttpParams = this.createHttpParams({ standardId: standardId, isCustom: isCustom });
        this.addPostAndPutHeaders();
        return this.http
            .get(`${this.idmApi}calculations/getflangematerials`, { headers: this.headers, params: params })
            .pipe(catchError(this.handleError.bind(this)));
    }

    getCalcgetGaskets(
        standardId: string,
        flangeFacingTypeId: string,
        pressureClassId: string,
        pipeSizeId: string,
        isStandardFlange: boolean,
        isRTJ: boolean,
        isCustom: boolean
    ): Observable<APIRes<GasketModel[]>> {
        const params: HttpParams = this.createHttpParams({
            standardId: standardId,
            flangeFacingTypeId: flangeFacingTypeId,
            pressureClassId: pressureClassId,
            pipeSizeId: pipeSizeId,
            isStandardFlange: isStandardFlange?.toString(),
            isRTJ: isRTJ?.toString(),
            isCustom: isCustom?.toString(),
        });

        this.addPostAndPutHeaders();
        return this.http.get(`${this.idmApi}calculations/getgaskets`, { headers: this.headers, params: params }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to search taggedItems************************** */
    // searchtaggeditems(payload: any): Observable<APIRes<{ total: number; data: SaerchedTaggedItem[] }>> {
    //     this.addPostAndPutHeaders();
    //     return this.http.post(`${this.idmApi}taggeditems/searchtaggeditems`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    // }

    //***************API Call to get Tagged Item Data By Tagged Item Id to edit************************** */
    getApprovals(): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.get(`${this.idmApi}approvals`, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    //***************API Call to save actions for Approvals************************** */
    saveActions(params: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.put(`${this.idmApi}approvals/actionapproval`, params, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }

    searchnames(payload: any): Observable<APIRes<any>> {
        this.addPostAndPutHeaders();
        return this.http.post(`${this.idmApi}search/searchnames`, payload, { headers: this.headers }).pipe(catchError(this.handleError.bind(this)));
    }
}
